import type { TranslationController } from '@adornis/translation-core/client/translation-controller.js';
import type { SinglePatch } from '@adornis/versioned-entity/db/versioned-mongo-entity.js';
import countries from '@chancenwerk/shared/master-data-management/countries.js';
import { DateTime } from 'luxon';

export const filterPatches = (translation: TranslationController<any>) => (p: SinglePatch) => {
  const trans = (path: string) => {
    return translation.translate('field', ...path?.split('/').slice(1)) ?? '';
  };

  return p.op === 'replace' && !trans(p.path ?? '').includes('field.');
};

export const formatPatchValue = (val: any, p: SinglePatch) => {
  switch (val) {
    case null:
    case 'null':
    case '"null"':
      return 'leer';
    case true:
    case 'true':
    case '"true"':
      return 'ja';
    case false:
    case 'false':
    case '"false"':
      return 'nein';
  }

  if (p.path === '/staatsangehoerigkeit') {
    return countries[JSON.parse(val)] ?? val.replaceAll('"', '');
  }

  try {
    const date = DateTime.fromISO(val.replaceAll('"', ''));
    if (date.isValid) {
      return date.toFormat('dd.MM.yyyy');
    }
  } catch (e) {}

  return val;
};
